// LLM generated - Model Claude 4 Sonnet
/**
 * Chat Widget height constants for consistent safe area calculations
 *
 * These values should match the actual rendered height of the ChatWidget component:
 * - Base height: padding (17px top + 17px bottom) + header (40px) = ~74px
 * - With notifications: base + subtitle (~30px) = ~104px
 * - Safe area: We use max height + extra buffer for safety = 120px
 */
export const CHAT_WIDGET_HEIGHT = {
  BASE: 74,
  WITH_NOTIFICATIONS: 104,
  SAFE_AREA: 120, // Used for bottom padding to prevent content overlap
} as const;
